import globalAxios from 'axios';
import axiosRetry from 'axios-retry';
import { ref } from 'vue';

const isLoading = ref(false);

axiosRetry(globalAxios, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
  shouldResetTimeout: true
});

globalAxios.interceptors.request.use(
  async (config) => {
    isLoading.value = true;
    return config;
  },
  (error) => {
    isLoading.value = false;
    return Promise.reject(error);
  }
);
globalAxios.interceptors.response.use(
  (config) => {
    isLoading.value = false;
    return config;
  },
  (error) => {
    isLoading.value = false;
    return Promise.reject(error);
  }
);

export { isLoading };
